import React from 'react'
import styled from 'styled-components'
import {
  headerBlackStyle,
  listDropStyle,
  magicContainerFullStyle,
  text1GrayStyle,
} from '../styled'
import LinkGetStarted from '../LinkGetStarted'
import Image from '../../Image'
import mediaQuery from 'styles/mediaQuery'

const Section = styled.section`
  position: relative;
  width: 100%;
  display: flex;
  background-color: #fbfbfe;
  height: auto;
  ${mediaQuery.tabletMax} {
    padding: 24px 16px;
  }
  ${mediaQuery.bigTabletMin} {
    padding: 60px 90px 55px 78px;
  }
  ${mediaQuery.desktopMin} {
    padding: 120px 182px 110px 156px;
    height: 600px;
  }
`

const Container = styled.div`
  ${magicContainerFullStyle};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  ${mediaQuery.bigTabletMin} {
    flex-direction: row;
    justify-content: center;
    gap: 90px;
  }
`

const TitlesWrapper = styled.div`
  ${mediaQuery.tabletMax} {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`

const Title = styled.h2`
  ${headerBlackStyle};
  margin-bottom: 24px;
  ${mediaQuery.mobile} {
    margin-bottom: 16px;
  }
`

const ListStyle = styled.ul`
  ${text1GrayStyle};
  margin-bottom: 24px;
  & > li {
    ${text1GrayStyle};
    ${listDropStyle};
    display: flex;
    position: relative;
    padding-left: 15px;
    margin-left: 8px;
  }
`

const ImageStyled = styled(Image)`
  width: 100%;
  max-width: 520px;
`

const translations = {
  header: 'Why should you care?',
  description: [
    'Access to millions of new shoppers',
    'Authentic relationship with your customer through your customers',
    'Launchpad for your brand and products, leading to discovery and awareness',
    'Drive sales',
  ],
  linkLabel: 'Get started',
}

const ContactFormSection = () => (
  <Section id="shouldCare">
    <Container>
      <ImageStyled fileName="newMagic/img1.png" alt={translations.header} />
      <TitlesWrapper>
        <Title>{translations.header}</Title>
        <ListStyle>
          {translations.description.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ListStyle>
        <LinkGetStarted linkLabel={translations.linkLabel} />
      </TitlesWrapper>
    </Container>
  </Section>
)

export default ContactFormSection
